import React, {Component} from "react";
import "./CurrencyConfiguration.css";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../configuration";
import Modal from "react-bootstrap/es/Modal";


class CurrencyConfiguration extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currencyValue: 0,
            effectiveDate: "",
            oldValue: 0,
            showConfirm: false,
            showSuccess: false,
            showError: false,
        };

        this.setCurrencyValue = this.setCurrencyValue.bind(this);
        this.updateCurrency = this.updateCurrency.bind(this);
        this.getCurrencyValue = this.getCurrencyValue.bind(this);
        this.handleShowConfirm = this.handleShowConfirm.bind(this);
        this.handleCloseConfirm = this.handleCloseConfirm.bind(this);
        this.handleCloseSuccessCurrency = this.handleCloseSuccessCurrency.bind(this);
    }

    componentDidMount() {
        this.getCurrencyValue();
    }

    handleCloseConfirm = () => {
        this.setState({
            showConfirm: false
        })
    };

    handleCloseErrorCurrency = () => {
        this.setState({
            showError: false
        })
    };


    handleShowConfirm = () => {
        this.setState({
            showConfirm: true
        })
    };

    handleCloseSuccessCurrency = () => {
        this.setState({
            showSuccess: false
        })
    };


    setCurrencyValue = (event) => {
        // console.log("VALUE =====> ", event.target.value);

        if (!isNaN(event.target.value)) {
            this.setState({
                currencyValue: event.target.value
            })
        }
    };

    getCurrencyValue = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/currency/details', axiosConfig)
            .then((res) => {
                console.log("CURRENCY RECEIVED ======> ", res.data);

                this.setState({
                    oldValue: res.data.rate,
                    currencyValue: res.data.rate,
                    effectiveDate: res.data.effectiveDate
                })
            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
            });
    };

    updateCurrency = () => {

        this.setState({
            showConfirm: false
        });

        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        // console.log("NEW VALUE =====> ", this.state.currencyValue);

        axios.post(RESOURCE_BASE_URL + 'api/currency/update', parseFloat(this.state.currencyValue), axiosConfig)
            .then((res) => {
                // console.log("CURRENCY UPDATE ======> ", res.data);
                this.setState({
                    showSuccess: true,
                    oldValue: res.data.rate,
                    effectiveDate: res.data.effectiveDate
                })
            })
            .catch((err) => {
                this.setState({
                    showError: true
                });
                console.log("AXIOS ERROR: ", err);
            });
    };

    render() {
        return (
            <div className="currency-config-div">
                <div className="currency-config-div-content">
                    <div className="title-1 text-align-left">
                        通貨構成
                    </div>
                    <hr/>
                    <div className="currency-config-content">
                        <div className="row">

                            <div className="col-md-4 custom-col-4">
                                <b>現在の設定：</b>
                            </div>
                            <div className="col-md-8 custom-col-8">
                                <b>{this.state.oldValue} JPY</b>
                            </div>
                        </div>
                        <br/>
                        <div className="row">

                            <div className="col-md-4 custom-col-4">
                                <b>発効日 :</b>
                            </div>
                            <div className="col-md-8 custom-col-8">
                                <b>{this.state.effectiveDate.year + " 年 " + this.state.effectiveDate.monthValue + " 月 " + this.state.effectiveDate.dayOfMonth + " 日 "}</b>
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-4 custom-col-4">
                                通貨：
                            </div>
                            <div className="col-md-8 custom-col-8">
                                JPY
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-4 custom-col-4">
                                通貨記号 :
                            </div>
                            <div className="col-md-8 custom-col-8">
                                YEN
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-4 custom-col-4">
                                レート編集：
                            </div>
                            <div className="col-md-8 custom-col-8">
                                <input type="text" className="inquiry-input-width" value={this.state.currencyValue} onChange={this.setCurrencyValue}/>
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col-md-4 custom-col-4">
                                &nbsp;
                            </div>
                            <div className="col-md-8 custom-col-8 btn-currency-config">
                                <button className="btn btn-primary" onClick={this.handleShowConfirm}>更新</button>
                            </div>
                        </div>
                    </div>

                </div>

                {/*confirm update---------------------------*/}
                <Modal dialogClassName="message-modal-currency message-modal-currency-remove-margin" show={this.state.showConfirm}
                       onHide={this.handleCloseConfirm}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            通貨レートを更新
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">
                                    通貨レートを更新してもよろしいですか？
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">
                            <div className="col-md-3">&nbsp;</div>
                            <div className="col-md-3">&nbsp;</div>
                            <div className="col-md-6">
                                <button className="btn btn-yes-currency btn-primary pull-left"
                                        onClick={this.updateCurrency}>
                                    はい
                                </button>
                                &nbsp;
                                <button className="btn btn-no-currency btn-secondary pull-right"
                                        onClick={this.handleCloseConfirm}>
                                    いいえ
                                </button>
                            </div>


                        </div>
                    </Modal.Footer>
                </Modal>


                {/*success update---------------------------*/}
                <Modal dialogClassName="message-modal-currency message-modal-currency-remove-margin" show={this.state.showSuccess}
                       onHide={this.handleCloseSuccessCurrency}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            通貨レートを更新
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">
                                    通貨レートが正常に更新されました
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">
                            <button className="btn btn-primary col-md-3 pull-right"
                                    onClick={this.handleCloseSuccessCurrency}>
                                閉じる
                            </button>


                        </div>
                    </Modal.Footer>
                </Modal>

                {/*success update---------------------------*/}
                <Modal dialogClassName="message-modal-currency" show={this.state.showError}
                       onHide={this.handleCloseErrorCurrency}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            通貨レートを更新
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">
                                    通貨レートの更新に失敗しました
                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">
                            <button className="btn btn-primary col-md-3 pull-right"
                                    onClick={this.handleCloseErrorCurrency}>
                                閉じる
                            </button>


                        </div>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }

}

export default CurrencyConfiguration;



// WEBPACK FOOTER //
// ./src/components/Admin/SystemConfiguration/CurrencyConfiguration/CurrencyConfiguration.js